import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTableModule } from '@angular/material/table';

import { DialogsModule } from '../../dialogs';

import { QRStatisticsTableComponent } from './qr-statistics-table.component';
import { QRStatisticsTableDialogComponent } from './dialog/qr-statistics-table-dialog.component';

const angularModules = [CommonModule, MatTableModule];
const lcModules = [DialogsModule];

const externalModules = [CommonModule, MatTableModule];
@NgModule({
  imports: [...angularModules, ...lcModules, QRStatisticsTableComponent, QRStatisticsTableDialogComponent],
  exports: [QRStatisticsTableComponent, ...externalModules],
})
export class QRStatisticsTableModule { }
